import { createFileRoute } from "@tanstack/react-router";

import { ProfileLayout } from "@/features/profile";

export const Route = createFileRoute("/profile")({
  component: ProfileLayout,
});
